import { useRef } from 'react';

export default function useDebounce(fn, delay, loading) {
    const timeoutRef = useRef(null);

    function debouncedFn(...args) {
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(() => {
            fn(...args);
            if (loading) loading(false);
        }, delay);
    }

    debouncedFn.cancel = () => {
        window.clearTimeout(timeoutRef.current);
    };

    return debouncedFn;
}
